import styled from 'styled-components';

import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

export const Container = styled.div`
  width: 100%;
  margin: 24px 0;
  display: flex;
  justify-content: space-between;
  gap: 72px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column;
  }
`;

export const FeatureItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;
`;

export const IconContainer = styled.div<{ $backgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;
